import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export const dateFormat = 'YYYY-MM-DD';

export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const formatDate = date => moment(date).format(dateFormat);
